import React from 'react'

const Grow = ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8rem" height="6rem" viewBox="0 0 115.304 69.195">
      <path id="grow-up" d="M116.837,9.573A5.853,5.853,0,0,0,111.534,6H82.717a5.764,5.764,0,0,0,0,11.527H97.644L65.426,49.745,46.464,30.725a5.763,5.763,0,0,0-8.184,0L3.7,65.306a5.787,5.787,0,1,0,8.184,8.184L42.372,42.944l18.962,19.02a5.764,5.764,0,0,0,8.184,0l36.252-36.31V40.581a5.764,5.764,0,1,0,11.527,0V11.764a5.763,5.763,0,0,0-.461-2.19Z" transform="translate(-1.994 -6)" fill={color} />
    </svg>

  )
}

export default Grow

